// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__1XeoP","item":"style_item__23Jlx","title":"style_title__3HAb6","points":"style_points__p9N2J"};